import { render, staticRenderFns } from "./ArtistsActivityLog.vue?vue&type=template&id=03f2f49e&"
import script from "./ArtistsActivityLog.vue?vue&type=script&lang=js&"
export * from "./ArtistsActivityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports